// Nurturing.jsx
import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate, useLocation , Link } from 'react-router-dom';
import axios from 'axios';
import { Table, Typography, Spin, Alert, Button, Modal, Input, Select ,Tag, DatePicker } from 'antd';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { UndoOutlined } from '@ant-design/icons';


const { Title, Paragraph } = Typography;
const { Search, TextArea } = Input;

const safe = (v) => (v === null || v === undefined || v === '' ? '-' : v);

// function formatDate(input) {
//   if (!input) return '-';
//   const d = new Date(input);
//   if (Number.isNaN(d.getTime())) return input;
//   const dd = String(d.getDate()).padStart(2, '0');
//   const mm = String(d.getMonth() + 1).padStart(2, '0');
//   const yy = d.getFullYear();
//   return `${dd}/${mm}/${yy}`;
// }

export default function Nurturing() {
  const navigate = useNavigate();
  const location = useLocation();

  const token = localStorage.getItem('token');
  const email = localStorage.getItem('email');
  const role = localStorage.getItem('role');

  const [showFilters, setShowFilters] = useState(false);

  
    const base =
     (role === 'ADMIN') ? "/admin-home"
      : "/user-home";

      const fullPath = `${base}/dashboard-nurturing`

  // auth verify (same logic as your other pages)
  useEffect(() => {
    const verifyUser = async () => {
      if (!token) {
        navigate('/login');
        return;
      }
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}/user/check-user`,
          { email, role, token }
        );
        if (!res.data.success) {
           const errMsg = res?.data?.message || 'Please Login Again.';
                toast.error(errMsg);
          localStorage.removeItem('token');
          localStorage.removeItem('tempToken');
          localStorage.removeItem('email');
          localStorage.removeItem('fullName');
          localStorage.removeItem('role');
          navigate('/login');
        }
      } catch (err) {
        // console.error('User verification failed:', err?.message || err);
         const msg = err?.response?.data?.message || err?.message || 'Please Login Again.';
            toast.error(msg);
        localStorage.removeItem('token');
        localStorage.removeItem('tempToken');
        localStorage.removeItem('email');
        localStorage.removeItem('fullName');
        localStorage.removeItem('role');
        navigate('/login');
      }
    };
    verifyUser();
  }, [navigate, location.pathname, token, email, role]);

  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // search & filter state
const [filterFullNameText, setFilterFullNameText] = useState('');
const [filterEmailText, setFilterEmailText] = useState('');
const [filterCategory, setFilterCategory] = useState(null); // 'STUDENT' | 'PROFESSIONAL' | null
const [filterSources, setFilterSources] = useState([]); // array of strings
const [filterAvailabilityMonth, setFilterAvailabilityMonth] = useState(null); // 'OCTOBER' etc
const [filterBatchDays, setFilterBatchDays] = useState([]); // ['MORNING','EVENING']
const [filterCallStatus, setFilterCallStatus] = useState(null); // 'PENDING' | 'COMPLETED'
const [filterNegotiationStatus, setFilterNegotiationStatus] = useState(null); // 'PENDING' | 'COMPLETED'
const [filterReason, setFilterReason] = useState(null); // reason codes or null
const [filterEnrollmentType, setFilterEnrollmentType] = useState(null); // 'JUNIOR PENETRATION TESTER' | 'SENIOR PENETRATION TESTER'
const [filterInstallment, setFilterInstallment] = useState(null); // 'YES' | 'NO'

// small helper normalizers
const normalize = (v) => (v === null || v === undefined ? '' : String(v).trim().toUpperCase());
const monthFromAvailability = (avail) => {
  // avail expected like "26-OCTOBER-2025" or "26-OCT-2025" etc — try to extract the month word
  if (!avail) return '';
  const parts = String(avail).split(/[-,\s]+/).map(p => p.trim()).filter(Boolean);
  // find first part that is alphabetic (month name)
  for (let p of parts) {
    if (/[A-Za-z]/.test(p)) {
      return p.toUpperCase();
    }
  }
  return '';
};

const clearFilters = () => {
  setFilterFullNameText('');
  setFilterEmailText('');
  setFilterCategory(null);
  setFilterSources([]);
  setFilterAvailabilityMonth(null);
  setFilterBatchDays([]);
  setFilterCallStatus(null);
  setFilterNegotiationStatus(null);
  setFilterReason(null);
  setFilterEnrollmentType(null);   // <- new
  setFilterInstallment(null);      // <- new
};



  // Inside component function (Nurturing) - add these new state variables:
const [actionModalVisible, setActionModalVisible] = useState(false);
const [actionRecord, setActionRecord] = useState(null);
const [movingKeys, setMovingKeys] = useState(new Set());

// Upcoming Batch modal state
const [upcomingModalVisible, setUpcomingModalVisible] = useState(false);
const [upcomingModalLoading, setUpcomingModalLoading] = useState(false);
const [upcomingDemoLinks, setUpcomingDemoLinks] = useState([]);
const [selectedUpcomingDemoKey, setSelectedUpcomingDemoKey] = useState(null);
const [selectedUpcomingDemoRow, setSelectedUpcomingDemoRow] = useState(null);
const [upcomingComments, setUpcomingComments] = useState('');
const [upcomingMovingKey, setUpcomingMovingKey] = useState(null);

// Drop modal state (if not already present)
const [dropModalVisible, setDropModalVisible] = useState(false);
const [dropComments, setDropComments] = useState('');
const [dropLoading, setDropLoading] = useState(false);

// Call Status modal state
const [callStatusModalVisible, setCallStatusModalVisible] = useState(false);
const [callStatusRecord, setCallStatusRecord] = useState(null); // selected lead record
const [callStatusValue, setCallStatusValue] = useState(null); // 'INTERESTED' | 'NOT INTERESTED' | null
const [callStatusLoading, setCallStatusLoading] = useState(false);

// Negotiation Status modal state
const [negotiationModalVisible, setNegotiationModalVisible] = useState(false);
const [negotiationRecord, setNegotiationRecord] = useState(null); // selected lead record
const [negotiationValue, setNegotiationValue] = useState(null); // 'COMPLETED' | 'PENDING' | null
const [negotiationLoading, setNegotiationLoading] = useState(false);

// Enrollment Type modal state
const [enrollmentModalVisible, setEnrollmentModalVisible] = useState(false);
const [enrollmentRecord, setEnrollmentRecord] = useState(null);
const [enrollmentValue, setEnrollmentValue] = useState(null); // e.g. 'JUNIOR PENETRATION TESTER'
const [enrollmentLoading, setEnrollmentLoading] = useState(false);

// Final Fee modal state
const [finalFeeModalVisible, setFinalFeeModalVisible] = useState(false);
const [finalFeeRecord, setFinalFeeRecord] = useState(null);
const [finalFeeValue, setFinalFeeValue] = useState(null); // numeric value
const [finalFeeLoading, setFinalFeeLoading] = useState(false);

// Installment modal state
const [installmentModalVisible, setInstallmentModalVisible] = useState(false);
const [installmentRecord, setInstallmentRecord] = useState(null);
const [installmentValue, setInstallmentValue] = useState(null); // 'YES' or 'NO'
const [installmentLoading, setInstallmentLoading] = useState(false);

// Reason Not Interested modal state
const [reasonModalVisible, setReasonModalVisible] = useState(false);
const [reasonRecord, setReasonRecord] = useState(null);
const [reasonValue, setReasonValue] = useState(null);
const [reasonLoading, setReasonLoading] = useState(false);

const [commentModalVisible, setCommentModalVisible] = useState(false);
const [commentRecord, setCommentRecord] = useState(null);
const [commentValue, setCommentValue] = useState("");
const [commentLoading, setCommentLoading] = useState(false);




  // fetch nurturing leads
  useEffect(() => {
    const fetchNurturing = async () => {
      if (!token) return;
      setLoading(true);
      setError(null);
      try {
        const url = `${process.env.REACT_APP_API_URL?.replace(/\/$/, '')}/nurturing/all-nurturing-leads`;
        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
          timeout: 20000,
        });
        const data = Array.isArray(res.data) ? res.data : res.data?.data || [];
        // ensure unique keys even if duplicate emails exist: use Email + index fallback
        setLeads(Array.isArray(data) ? data.map((r, i) => ({ key: `${r.Email ?? 'lead'}-${i}`, ...r })) : []);
      } catch (err) {
        console.error('Failed to fetch nurturing leads', err);
        if (err?.response?.status === 401 || err?.response?.status === 403) {
          toast.error('Session expired. Please login again.');
          localStorage.clear();
          navigate('/login');
          return;
        }
        setError('Failed to load nurturing leads');
        toast.error('Failed to load nurturing leads');
      } finally {
        setLoading(false);
      }
    };

    fetchNurturing();
  }, [token, location.key, navigate]);


  const handleUpdateComment = async () => {
  if (!commentRecord?.Email) {
    toast.error("No lead selected");
    return;
  }

  if (!commentValue.trim()) {
    toast.error("Please enter comment");
    return;
  }

  setCommentLoading(true);

  try {
    const url = `${process.env.REACT_APP_API_URL?.replace(
      /\/$/,
      ""
    )}/nurturing/update-comment`;

    const payload = {
      Email: commentRecord.Email,
      Comment: commentValue.trim(),
    };

    const res = await axios.put(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      timeout: 15000,
    });

    if (res?.data?.success || res?.status === 200 || res?.status === 201) {
      toast.success(res?.data?.message || "Comment updated successfully");

      setLeads((prev) =>
        prev.map((r) =>
          r.key === commentRecord.key
            ? { ...r, Comment: commentValue.trim() }
            : r
        )
      );

      setCommentModalVisible(false);
      setCommentRecord(null);
      setCommentValue("");
    } else {
      toast.error(res?.data?.message || "Failed to update comment");
    }
  } catch (err) {
    console.error("update-comment error", err);
    toast.error(
      err?.response?.data?.message ||
        err?.message ||
        "Network/server error"
    );
  } finally {
    setCommentLoading(false);
  }
};

  const [leadStatusModalVisible, setLeadStatusModalVisible] = useState(false);
  const [leadStatusRecord, setLeadStatusRecord] = useState(null);
  const [leadStatusValue, setLeadStatusValue] = useState(null);
  const [leadStatusLoading, setLeadStatusLoading] = useState(false);

  // Columns based on your schema
  const nurturingColumns = [
    { title: <span className="text-[17px] font-bold text-white">Full Name</span>, dataIndex: 'FullName', key: 'FullName', width: 240, render: (t) => <span className="font-bold whitespace-nowrap">{safe(t)}</span> },
    { title: <span className="text-[17px] font-bold text-white whitespace-nowrap">Email</span>, dataIndex: 'Email', key: 'Email', width: 260, render: (t) => <span className="font-bold whitespace-nowrap">{safe(t)}</span> },
    { title: <span className="text-[17px] font-bold text-white">Phone Number</span>, dataIndex: 'PhoneNumber', key: 'PhoneNumber', width: 170, render: (t) => <span className="whitespace-nowrap">{safe(t)}</span> },
    { title: <span className="text-[17px] font-bold text-white">Lead Category</span>, dataIndex: 'LeadCategory', key: 'LeadCategory', width: 150, render: (t) => <span className="ml-5 text-sm font-bold whitespace-nowrap">{safe(t)}</span> },
   { title: <span className="text-[17px] font-bold text-white">Lead Date</span>, dataIndex: 'LeadDate', key: 'LeadDate', width: 120, render: (d) => <span className="font-extrabold text-center text-blue-700 whitespace-nowrap">{safe(d)}</span> },
    { title: <span className="text-[17px] font-bold text-white">Lead Source</span>, dataIndex: 'LeadSource', key: 'LeadSource', width: 210, render: (t) => <span className="ml-4 text-sm font-bold whitespace-nowrap">{safe(t)}</span> },
{
  title: (
    <span className="text-[17px] font-bold text-white">
      Lead Status
    </span>
  ),
  dataIndex: "LeadStatus",
  key: "LeadStatus",
  width: 240,
  align: "center",
  render: (t, record) => {
    const raw = t ?? "PENDING";
    const value = String(raw).trim().toUpperCase();

    const statusStyles = {
      "HOT LEAD": {
        backgroundColor: "#16a34a", // green
        borderColor: "#16a34a",
        color: "#fff",
      },
      "WARM LEAD": {
        backgroundColor: "#f97316", // orange
        borderColor: "#f97316",
        color: "#fff",
      },
      "COLD LEAD": {
        backgroundColor: "#000000", // black
        borderColor: "#000000",
        color: "#fff",
      },
      "PENDING": {
        backgroundColor: "#dc2626", // red
        borderColor: "#dc2626",
        color: "#fff",
      },
    };

    const style = statusStyles[value] || statusStyles["PENDING"];

    return (
      <div className="flex justify-center">
        <button
          type="button"
          onClick={() => {
            setLeadStatusRecord(record);

            const cur = String(record?.LeadStatus ?? "")
              .trim()
              .toUpperCase();

            setLeadStatusValue(cur && cur !== "PENDING" ? cur : null);
            setLeadStatusModalVisible(true);
          }}
          className="px-3 py-1.5 rounded-md font-semibold shadow-sm whitespace-nowrap text-sm"
          style={{ minWidth: 110, ...style }}
        >
          {value}
        </button>
      </div>
    );
  },
},
    {
  title: (
    <span className="text-[17px] font-bold text-white">
      Availability Batch
    </span>
  ),
  dataIndex: "AvailabilityBatch",
  key: "AvailabilityBatch",
  width: 220,
  align: "center",
  render: (t, record) => (
    <div className="flex flex-col items-center gap-1">
      <span className="text-sm font-bold text-green-700 whitespace-nowrap">
        {safe(t)}
      </span>

      <button
        type="button"
        onClick={() => {
          setChangeBatchRecord(record);
          setChangedBatchDate(null);
          setChangeBatchModalVisible(true);
        }}
        className="px-2 py-0.5 text-xs font-semibold text-sm text-white border bg-red-600 border-slate-600 rounded hover:bg-blue-600 hover:text-white"
      >
        Change
      </button>
    </div>
  ),
},
    { title: <span className="text-[17px] font-bold text-white">Batch Start Date</span>, dataIndex: 'BatchStartDate', key: 'BatchStartDate', width: 170, render: (d) => <span className="ml-3 font-extrabold text-amber-700 whitespace-nowrap">{(d)}</span> },
    { title: <span className="text-[17px] font-bold text-white justify-center items-center">Batch Day</span>, dataIndex: 'BatchDay', key: 'BatchDay', width: 120, render: (t) => <span className="font-bold whitespace-nowrap ">{safe(t)}</span> },

   {
  title: <span className="text-[17px] font-bold text-white">Call Status</span>,
  dataIndex: 'CallStatus',
  key: 'CallStatus',
  width: 170,
  align: 'center',
  render: (t, record) => {
    const status = String(t ?? 'PENDING').toUpperCase();
    const isPending = status === 'PENDING' ;

    const style = isPending
      ? { backgroundColor: '#dc2626', borderColor: '#dc2626', color: '#fff' } // red
      : { backgroundColor: '#16a34a', borderColor: '#16a34a', color: '#fff' }; // green

    return (
      <div className="flex justify-center">
        <button
          type="button"
          onClick={() => {
            // open modal for this record
            setCallStatusRecord(record);
            // preselect non-PENDING states, otherwise leave null
            const cur = String(record?.CallStatus ?? 'PENDING').toUpperCase();
            setCallStatusValue(cur !== 'PENDING' ? cur : null);
            setCallStatusModalVisible(true);
          }}
          className="px-3 py-1.5 rounded-md font-semibold whitespace-nowrap shadow-sm text-sm"
          style={{ minWidth: 100, ...style }}
        >
          {status}
        </button>
      </div>
    );
  },
},

{
  title: <span className="text-[17px] font-bold text-white">Comment</span>,
  dataIndex: "Comment",
  key: "Comment",
  width: 360,
  align: "center",
  render: (t, record) => {
    const comment = t || "No comment";

    return (
      <div className="flex flex-col items-center gap-2">
        <span className="max-w-[290px] truncate text-sm font-semibold text-gray-700">
          {comment}
        </span>

        <Button
          size="small"
          type="primary"
          onClick={() => {
            setCommentRecord(record);
            setCommentValue(record?.Comment || "");
            setCommentModalVisible(true);
          }}
          className="!bg-purple-700 hover:!bg-purple-900 !font-bold"
        >
          Update
        </Button>
      </div>
    );
  },
},

   {
  title: <span className="text-[17px] font-bold text-white">Negotiation status</span>,
  dataIndex: 'NegotiationStatus',
  key: 'NegotiationStatus',
  width: 200,
  align: 'center',
  render: (t, record) => {
    const status = String(t ?? 'PENDING').toUpperCase();
    const isPending = status === 'PENDING' ;

    const style = isPending
      ? { backgroundColor: '#dc2626', borderColor: '#dc2626', color: '#fff' } // red
      : { backgroundColor: '#16a34a', borderColor: '#16a34a', color: '#fff' }; // green

    return (
      <div className="flex justify-center">
        <button
          type="button"
          onClick={() => {
            setNegotiationRecord(record);
            const cur = String(record?.NegotiationStatus ?? 'PENDING').toUpperCase();
            setNegotiationValue(cur !== 'PENDING' ? cur : null);
            setNegotiationModalVisible(true);
          }}
          className="px-3 py-1.5 rounded-md font-semibold whitespace-nowrap shadow-sm text-sm"
          style={{ minWidth: 120, ...style }}
        >
          {status}
        </button>
      </div>
    );
  },
},

   
   {
  title: <span className="text-[17px] font-bold text-white">Enrollment Type</span>,
  dataIndex: 'EnrollmentType',
  key: 'EnrollmentType',
  width: 260,
  align: 'center',
  render: (t, record) => {
    const value = String(t ?? 'PENDING').toUpperCase();
   const isPending = value === "PENDING" || value === "" || value === null;

const isJunior = record?.EnrollmentType === "JUNIOR PENETRATION TESTER";

const style2 = isJunior
  ? { backgroundColor: "#2563eb", borderColor: "#2563eb", color: "#fff" }
  : { backgroundColor: "#16a34a", borderColor: "#16a34a", color: "#fff" };

const style = isPending
  ? { backgroundColor: "#dc2626", borderColor: "#dc2626", color: "#fff" }
  : style2;

    return (
      <div className="flex justify-center">
        <button
          type="button"
          onClick={() => {
            setEnrollmentRecord(record);
            const cur = String(record?.EnrollmentType ?? '').toUpperCase();
            setEnrollmentValue(cur && cur !== 'PENDING' ? cur : null);
            setEnrollmentModalVisible(true);
          }}
          className="px-3 py-1.5 rounded-md font-semibold whitespace-nowrap shadow-sm"
          style={{ minWidth: 120, ...style }}
        >
          {value === '' ? '-' : value}
        </button>
      </div>
    );
  },
},

{
  title: <span className="text-[17px] font-bold text-white">Final Fee</span>,
  dataIndex: 'FinalFee',
  key: 'FinalFee',
  width: 180,
  align: 'center',
  render: (t, record) => {
    // show '-' when null/undefined
    const display = t !== null && t !== undefined ? t : '-';

    // if it's not set show a red button prompting change, otherwise green-ish button showing value
    const isSet = t !== null && t !== undefined;
    const style = isSet
      ? { backgroundColor: '#16a34a', borderColor: '#16a34a', color: '#fff' }
      : { backgroundColor: '#dc2626', borderColor: '#dc2626', color: '#fff' };

    return (
      <div className="flex justify-center">
        <button
          type="button"
          onClick={() => {
            // open modal and preselect based on existing value or EnrollmentType
            setFinalFeeRecord(record);
            // if there's already a numeric value, preselect it; else null
            setFinalFeeValue(t !== null && t !== undefined ? Number(t) : null);
            setFinalFeeModalVisible(true);
          }}
          className="px-3 py-1.5 rounded-md font-semibold whitespace-nowrap shadow-sm"
          style={{ minWidth: 120, ...style }}
        >
          {isSet ? display : 'Set Final Fee'}
        </button>
      </div>
    );
  },
},
{
  title: <span className="text-[17px] font-bold text-white">Installment</span>,
  dataIndex: 'Installment',
  key: 'Installment',
  width: 140,
  align: 'center',
  render: (t, record) => {
    const status = String(t ?? 'PENDING').toUpperCase();
    const isYes = status === 'YES';
    // const isPendingOrNo = status === 'PENDING' || status === 'NO';

    const style = isYes
      ? { backgroundColor: '#16a34a', borderColor: '#16a34a', color: '#fff' } // green
      : { backgroundColor: '#dc2626', borderColor: '#dc2626', color: '#fff' }; // red

    return (
      <div className="flex justify-center">
        <button
          type="button"
          onClick={() => {
            setInstallmentRecord(record);
            // preselect current value; convert PENDING -> null so user can choose
            setInstallmentValue(status === 'YES' ? 'YES' : status === 'NO' ? 'NO' : null);
            setInstallmentModalVisible(true);
          }}
          className="px-3 py-1.5 rounded-md font-semibold whitespace-nowrap shadow-sm"
          style={{ minWidth: 120, ...style }}
        >
          {status === 'PENDING' ? 'PENDING' : status}
        </button>
      </div>
    );
  },
},
{
  title: <span className="text-[17px] font-bold text-white">Reason Not Interested</span>,
  dataIndex: 'ReasonForNotInterest',
  key: 'ReasonForNotInterest',
  width: 320,
  render: (t, record) => {
    const value = safe(t);
    // show a button that opens the modal; style indicates presence/absence
    const isEmpty = !t || t === '-' || t === null;
    const btnStyle = isEmpty
      ? { backgroundColor: '#dc2626', borderColor: '#dc2626', color: '#fff' } // red when empty
      : { backgroundColor: '#16a34a', borderColor: '#16a34a', color: '#fff' }; // green if set

    return (
      <div className="flex items-center justify-center">
        <button
          type="button"
          onClick={() => {
            setReasonRecord(record);
            // preselect current reason if present, otherwise null
            setReasonValue(t && t !== '-' ? t : null);
            setReasonModalVisible(true);
          }}
          style={{ minWidth: 150, ...btnStyle }}
          className="px-3 py-1.5 rounded-md font-semibold whitespace-nowrap shadow-sm"
        >
          {value === '-' ? 'No Reason (Set)' : String(value)}
        </button>
      </div>
    );
  },
},
     {
      title: (
        <span className="font-bold text-[17px] text-white whitespace-nowrap">
          Action
        </span>
      ),
      key: 'action',
      fixed: 'right',
      width: 200,
      align: 'center',
      render: (_, record) => {
        return (
          <div className="flex items-center justify-center gap-2">
            <button
              onClick={() => openActionModal(record)}
              className={`px-4 py-2 rounded-md text-white font-semibold transition-colors duration-200 whitespace-nowrap bg-gradient-to-r from-blue-600 to-blue-500 hover:from-red-700 hover:to-rose-600 shadow`}
              type="button"
            >
              Actions
            </button>
          </div>
        );
      },
    }
  ];

  
  const demoLinksColumns = [
    { title: 'DemoDate', dataIndex: 'DemoDate', key: 'DemoDate', width: 140, render: (d) => <span className="font-bold whitespace-nowrap">{safe(d)}</span> },
    { title: 'Day', dataIndex: 'Day', key: 'Day', width: 80, render: (t) => <span className="whitespace-nowrap">{safe(t)}</span> },
    { title: 'Month', dataIndex: 'Month', key: 'Month', width: 100, render: (t) => <span className="font-bold text-amber-600 whitespace-nowrap">{safe(t)}</span> },
    { title: 'Year', dataIndex: 'Year', key: 'Year', width: 100, render: (t) => <span className="whitespace-nowrap">{safe(t)}</span> },
    { title: 'Time', dataIndex: 'Time', key: 'Time', width: 120, render: (t) => <span className="whitespace-nowrap">{safe(t)}</span> },
    { title: 'BatchStartDate', dataIndex: 'BatchStartDate', key: 'BatchStartDate', width: 140, render: (d) => <span className="font-bold text-green-600 whitespace-nowrap">{safe(d)}</span> },
    { title: 'BatchDay', dataIndex: 'BatchDay', key: 'BatchDay', width: 100, render: (t) => <span className="font-bold whitespace-nowrap">{safe(t)}</span> },
    { title: 'BatchTime', dataIndex: 'BatchTime', key: 'BatchTime', width: 120, render: (t) => <span className="whitespace-nowrap">{safe(t)}</span> },
    { title: 'DemoLink', dataIndex: 'DemoLink', key: 'DemoLink', width: 260, render: (t) => t ? <a className="truncate inline-block max-w-[220px] whitespace-nowrap" href={t} target="_blank" rel="noreferrer">{t}</a> : <span>-</span> },
    { title: 'DemoRecordingLink', dataIndex: 'DemoRecordingLink', key: 'DemoRecordingLink', width: 260, render: (t) => t ? <a className="truncate inline-block max-w-[220px] whitespace-nowrap" href={t} target="_blank" rel="noreferrer">{t}</a> : <span>-</span> },
  ];
  
  
  // filteredLeads based on all filters + search fields
const filteredLeads = useMemo(() => {
  if (!Array.isArray(leads)) return [];

  // build uppercase normalized selections for efficient checks
  const catFilter = normalize(filterCategory);
  const sourcesFilter = (filterSources || []).map(s => normalize(s));
  const batchDaysFilter = (filterBatchDays || []).map(d => normalize(d));
  const availMonthFilter = normalize(filterAvailabilityMonth);
  const nameQ = (filterFullNameText || '').trim().toLowerCase();
  const emailQ = (filterEmailText || '').trim().toLowerCase();
  const callStatusFilter = normalize(filterCallStatus);
  const negotiationFilter = normalize(filterNegotiationStatus);
  const reasonFilter = normalize(filterReason);

  return leads.filter((r) => {
    // Category filter (single)
    if (catFilter) {
      if (normalize(r.LeadCategory) !== catFilter) return false;
    }

    // Source multi
    if (sourcesFilter.length > 0) {
      const src = normalize(r.LeadSource);
      if (!sourcesFilter.includes(src)) return false;
    }

    // Batch Day multi
    if (batchDaysFilter.length > 0) {
      const bd = normalize(r.BatchDay);
      if (!batchDaysFilter.includes(bd)) return false;
    }

    // Availability month (extract from AvailabilityBatch field)
    if (availMonthFilter) {
      const month = monthFromAvailability(r.AvailabilityBatch);
      if (!month) return false;
      if (normalize(month) !== availMonthFilter) return false;
    }

    // Demo/Call status
    if (callStatusFilter) {
      if (normalize(r.CallStatus) !== callStatusFilter) return false;
    }

    // Negotiation status
    if (negotiationFilter) {
      if (normalize(r.NegotiationStatus) !== negotiationFilter) return false;
    }

    // EnrollmentType
  if (filterEnrollmentType) {
    if (normalize(r.EnrollmentType) !== normalize(filterEnrollmentType)) return false;
  }

  // Installment (YES/NO)
  if (filterInstallment) {
    if (normalize(r.Installment) !== normalize(filterInstallment)) return false;
  }

    // ReasonForNotInterest
if (reasonFilter) {
  const rr = normalize(r.ReasonForNotInterest);
  // now backend uses "NOT APPLICABLE" explicitly, so just compare normalized values
  if (reasonFilter === 'NOT APPLICABLE') {
    if (rr !== 'NOT APPLICABLE') return false;
  } else {
    if (rr !== normalize(reasonFilter)) return false;
  }
}

    // FullName search (partial, case-insensitive)
    if (nameQ) {
      const nm = (r.FullName || '').toLowerCase();
      if (!nm.includes(nameQ)) return false;
    }

    // Email search (partial, case-insensitive)
    if (emailQ) {
      const em = (r.Email || '').toLowerCase();
      if (!em.includes(emailQ)) return false;
    }

    return true;
  });
}, [leads, filterCategory, filterSources, filterAvailabilityMonth, filterBatchDays, filterFullNameText, filterEmailText, filterCallStatus, filterNegotiationStatus, filterReason, filterEnrollmentType, filterInstallment]);


  // helper to set/unset movingKeys
const setMoving = (key, on = true) => {
  setMovingKeys(prev => {
    const next = new Set(prev);
    if (on) next.add(key);
    else next.delete(key);
    return next;
  });
};

// open Action modal
const openActionModal = (record) => {
  setActionRecord(record);
  setActionModalVisible(true);
};

// --- Move to Nurturing ---
const handleMoveToFirstInstallment = async (record) => {
  if (!record || !record.Email) return toast.error('Invalid record');
  const key = `move-nurture-${record.key}`;
  setMoving(key, true);

  try {
    const url = `${process.env.REACT_APP_API_URL?.replace(/\/$/, '')}/nurturing/move-to-first-installment-stage`;
    const payload = {
      Email: record.Email
    };

    const res = await axios.post(url, payload, {
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      timeout: 15000,
    });

    if (res?.data?.success || res?.status === 200 || res?.status === 201) {
      toast.success(res?.data?.message || 'Moved to Nurturing');
      // remove from local list
      setLeads(prev => prev.filter(r => r.key !== record.key));
      setActionModalVisible(false);
    } else {
      toast.error(res?.data?.message || 'Failed to move to nurturing');
    }
  } catch (err) {
    console.error('move-to-nurturing error', err);
    const msg = err?.response?.data?.message || err?.message || 'Network/server error';
    toast.error(msg);
  } finally {
    setMoving(key, false);
  }
};

// --- Open Upcoming Batch modal and load available batches (demolinks) ---
const openUpcomingModal = async (record) => {
  if (!record) return;
  setActionRecord(record);
  setUpcomingModalVisible(true);
  setSelectedUpcomingDemoKey(null);
  setSelectedUpcomingDemoRow(null);
  setUpcomingComments('');
  setUpcomingDemoLinks([]);
  setUpcomingModalLoading(true);

  try {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/demolinks/all-demolinks`, {
      headers: { Authorization: `Bearer ${token}` },
      timeout: 15000,
    });
    const data = Array.isArray(res.data) ? res.data : res.data?.data || res.data?.links || [];
    setUpcomingDemoLinks(Array.isArray(data) ? data.map((r,i)=>({ key: r.id ?? `dl-${i}`, ...r })) : []);
  } catch (err) {
    console.error('Failed to fetch demolinks for upcoming batches', err);
    toast.error('Failed to load batches');
  } finally {
    setUpcomingModalLoading(false);
  }
};

const handleSelectUpcomingRow = (rec) => {
  setSelectedUpcomingDemoKey(rec.key);
  setSelectedUpcomingDemoRow(rec);
};

// --- Confirm Move To Upcoming Batch ---
const handleConfirmMoveToUpcomingBatch = async () => {
  if (!actionRecord || !selectedUpcomingDemoRow) {
    toast.error('Select a batch first');
    return;
  }

 const record = actionRecord;
   const selectedRow = upcomingDemoLinks.find((r) => r.key === selectedUpcomingDemoKey);
   // console.log(selectedRow);
   
   if (!selectedRow) {
     toast.error('Select a batch option first');
     return;
   }
 
   const AvailabilityBatch = `${selectedRow.Day}-${selectedRow.Month}-${selectedRow.Year}`
   if (!AvailabilityBatch || AvailabilityBatch === '-') {
     toast.error('Selected batch has invalid date');
     return;
   }
 
   const BatchDay = selectedRow.BatchDay ;
   const Comments = upcomingComments ;
 
   const payload = {
     Email: record.Email,
     AvailabilityBatch,
     BatchDay,
     Comments,
   };
 
   const key = `move-upcoming-${record.key}`;
   setMoving(key, true);
   setUpcomingMovingKey(key);

  try {
    const url = `${process.env.REACT_APP_API_URL?.replace(/\/$/, '')}/nurturing/move-to-upcoming-batch`;
    const res = await axios.post(url, payload, {
      headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      timeout: 20000,
    });

    if (res?.data?.success || res?.status === 200 || res?.status === 201) {
      toast.success(res?.data?.message || 'Moved to upcoming batch');
      // remove lead from UI list
      setLeads(prev => prev.filter(r => r.key !== actionRecord.key));
      setUpcomingModalVisible(false);
      setActionModalVisible(false);
    } else {
      toast.error(res?.data?.message || 'Failed to move to upcoming batch');
    }
  } catch (err) {
    console.error('move-to-upcoming-batch error', err);
    const msg = err?.response?.data?.message || err?.message || 'Network/server error';
    toast.error(msg);
  } finally {
    setMoving(key, false);
    setUpcomingMovingKey(null);
  }
};

// --- Drop The Lead (use drop modal with comments) ---
// const openDropModal = (record) => {
//   setActionRecord(record);
//   setDropComments('');
//   setDropModalVisible(true);
// };


  const handleDropLeadConfirm = async (record) => {
    if (!record?.Email) {
      toast.error('No email present for selected lead');
      return;
    }

    const key = `drop-lead-${record.key}`;
    setMovingKeys(prev => {
      const next = new Set(prev); next.add(key); return next;
    });
    setDropLoading(true);

    try {
      const payload = { Email: record.Email, Comments: dropComments ?? '' };
      const url = `${process.env.REACT_APP_API_URL?.replace(/\/$/, '')}/nurturing/drop-lead`;
      const res = await axios.post(url, payload, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        timeout: 15000,
      });

      if (res?.data?.success || [200,201].includes(res?.status)) {
        toast.success(res?.data?.message || 'Lead dropped successfully');
        setLeads(prev => prev.filter(r => r.key !== record.key));
        setDropModalVisible(false);
        setActionModalVisible(false);
      } else {
        const msg = res?.data?.message || 'Failed to drop lead';
        toast.error(msg);
      }
    } catch (err) {
      console.error('Drop lead error', err);
      const msg = err?.response?.data?.message || err.message || 'Network/server error';
      toast.error(msg);
    } finally {
      setDropLoading(false);
      setMovingKeys(prev => {
        const next = new Set(prev); next.delete(key); return next;
      });
    }
  };

  // Change Call Status API call (PUT)
const handleChangeCallStatus = async () => {
  if (!callStatusRecord || !callStatusRecord.Email) {
    toast.error('No lead selected');
    return;
  }
  if (!callStatusValue) {
    toast.error('Please choose a status');
    return;
  }

  setCallStatusLoading(true);
  try {
    const url = `${process.env.REACT_APP_API_URL?.replace(/\/$/, '')}/nurturing/update-call-status`;
    const payload = {
      Email: callStatusRecord.Email,
      CallStatus: callStatusValue,
    };

    const res = await axios.put(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      timeout: 15000,
    });

    if (res?.data?.success || res?.status === 200 || res?.status === 201) {
      toast.success(res?.data?.message || 'Call status updated');

      // update local UI - keep other fields intact
      setLeads((prev) =>
        prev.map((r) => (r.key === callStatusRecord.key ? { ...r, CallStatus: callStatusValue } : r))
      );

      setCallStatusModalVisible(false);
    } else {
      const msg = res?.data?.message || 'Failed to update call status';
      toast.error(msg);
    }
  } catch (err) {
    console.error('change-call-status error', err);
    const msg = err?.response?.data?.message || err?.message || 'Network/server error';
    toast.error(msg);
  } finally {
    setCallStatusLoading(false);
  }
};

// Change Negotiation Status API call (PUT)
const handleChangeNegotiationStatus = async () => {
  if (!negotiationRecord || !negotiationRecord.Email) {
    toast.error('No lead selected');
    return;
  }
  if (!negotiationValue) {
    toast.error('Please choose a negotiation status');
    return;
  }

  setNegotiationLoading(true);
  try {
    const url = `${process.env.REACT_APP_API_URL?.replace(/\/$/, '')}/nurturing/update-negotiation-status`;
    const payload = {
      Email: negotiationRecord.Email,
      NegotiationStatus: negotiationValue,
    };

    const res = await axios.put(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      timeout: 15000,
    });

    if (res?.data?.success || res?.status === 200 || res?.status === 201) {
      toast.success(res?.data?.message || 'Negotiation status updated');

      // update local UI - keep other fields intact
      setLeads((prev) =>
        prev.map((r) => (r.key === negotiationRecord.key ? { ...r, NegotiationStatus: negotiationValue } : r))
      );

      setNegotiationModalVisible(false);
    } else {
      const msg = res?.data?.message || 'Failed to update negotiation status';
      toast.error(msg);
    }
  } catch (err) {
    console.error('change-negotiation-status error', err);
    const msg = err?.response?.data?.message || err?.message || 'Network/server error';
    toast.error(msg);
  } finally {
    setNegotiationLoading(false);
  }
};


// Change Enrollment Type API call (PUT)
const handleChangeEnrollmentType = async () => {
  if (!enrollmentRecord || !enrollmentRecord.Email) {
    toast.error('No lead selected');
    return;
  }
  if (!enrollmentValue) {
    toast.error('Please choose an enrollment type');
    return;
  }

  setEnrollmentLoading(true);
  try {
    const url = `${process.env.REACT_APP_API_URL?.replace(/\/$/, '')}/nurturing/update-enrollmenttype`;
    const payload = {
      Email: enrollmentRecord.Email,
      EnrollmentType: enrollmentValue,
    };

    const res = await axios.put(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      timeout: 15000,
    });

    if (res?.data?.success || res?.status === 200 || res?.status === 201) {
      toast.success(res?.data?.message || 'Enrollment type updated');

      // update local leads array
      setLeads(prev => prev.map(r => r.key === enrollmentRecord.key ? { ...r, EnrollmentType: enrollmentValue } : r));

      setEnrollmentModalVisible(false);
    } else {
      const msg = res?.data?.message || 'Failed to update enrollment type';
      toast.error(msg);
    }
  } catch (err) {
    console.error('change-enrollment-type error', err);
    const msg = err?.response?.data?.message || err?.message || 'Network/server error';
    toast.error(msg);
  } finally {
    setEnrollmentLoading(false);
  }
};

// Change Final Fee API call (PUT)
const handleChangeFinalFee = async () => {
  if (!finalFeeRecord || !finalFeeRecord.Email) {
    toast.error('No lead selected');
    return;
  }

  // allow updating even if null initially; ensure numeric
  const value = finalFeeValue === null || finalFeeValue === undefined ? null : Number(finalFeeValue);

  if (value === null || Number.isNaN(value)) {
    toast.error('Please select a valid fee value');
    return;
  }

  setFinalFeeLoading(true);
  try {
    const url = `${process.env.REACT_APP_API_URL?.replace(/\/$/, '')}/nurturing/update-final-fee`;
    const payload = {
      Email: finalFeeRecord.Email,
      FinalFee: value,
    };

    const res = await axios.put(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      timeout: 15000,
    });

    if (res?.data?.success || res?.status === 200 || res?.status === 201) {
      toast.success(res?.data?.message || 'Final fee updated');

      // update local leads array with new numeric fee
      setLeads(prev => prev.map(r => r.key === finalFeeRecord.key ? { ...r, FinalFee: value } : r));

      setFinalFeeModalVisible(false);
    } else {
      const msg = res?.data?.message || 'Failed to update final fee';
      toast.error(msg);
    }
  } catch (err) {
    console.error('change-final-fee error', err);
    const msg = err?.response?.data?.message || err?.message || 'Network/server error';
    toast.error(msg);
  } finally {
    setFinalFeeLoading(false);
  }
};

// Change Installment (PUT)
const handleChangeInstallment = async () => {
  if (!installmentRecord || !installmentRecord.Email) {
    toast.error('No lead selected');
    return;
  }

  if (!installmentValue) {
    toast.error('Select Installment value (YES / NO)');
    return;
  }

  setInstallmentLoading(true);
  try {
    const url = `${process.env.REACT_APP_API_URL?.replace(/\/$/, '')}/nurturing/update-installment`;
    const payload = {
      Email: installmentRecord.Email,
      Installment: installmentValue,
    };

    const res = await axios.put(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      timeout: 15000,
    });

    if (res?.data?.success || res?.status === 200 || res?.status === 201) {
      toast.success(res?.data?.message || 'Installment updated');

      // update local leads array
      setLeads(prev => prev.map(r => r.key === installmentRecord.key ? { ...r, Installment: installmentValue } : r));

      setInstallmentModalVisible(false);
    } else {
      const msg = res?.data?.message || 'Failed to update installment';
      toast.error(msg);
    }
  } catch (err) {
    console.error('change-installment error', err);
    const msg = err?.response?.data?.message || err?.message || 'Network/server error';
    toast.error(msg);
  } finally {
    setInstallmentLoading(false);
  }
};


// Change Reason For Not Interested (PUT)
const handleChangeReason = async () => {
  if (!reasonRecord || !reasonRecord.Email) {
    toast.error('No lead selected');
    return;
  }

  if (!reasonValue) {
    toast.error('Select a reason');
    return;
  }

  setReasonLoading(true);
  try {
    const url = `${process.env.REACT_APP_API_URL?.replace(/\/$/, '')}/nurturing/update-reason-for-not-interest`;
    const payload = {
      Email: reasonRecord.Email,
      Reason: reasonValue,
    };

    const res = await axios.put(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      timeout: 15000,
    });

    if (res?.data?.success || res?.status === 200 || res?.status === 201) {
      toast.success(res?.data?.message || 'Reason updated');

      // update local leads array so table reflects change immediately
      setLeads(prev => prev.map(r => r.key === reasonRecord.key ? { ...r, ReasonForNotInterest: reasonValue } : r));

      setReasonModalVisible(false);
    } else {
      const msg = res?.data?.message || 'Failed to update reason';
      toast.error(msg);
    }
  } catch (err) {
    console.error('change-reason error', err);
    const msg = err?.response?.data?.message || err?.message || 'Network/server error';
    toast.error(msg);
  } finally {
    setReasonLoading(false);
  }
};


const [customAmount, setCustomAmount] = useState(() => {
  return finalFeeValue != null ? String(finalFeeValue) : "";
});

// compute presetOptions once per record
const presetOptions = useMemo(() => {
  const et = (finalFeeRecord?.EnrollmentType || "").toString().toUpperCase();
  if (et === "JUNIOR PENETRATION TESTER") {
    return [25000,24500,24000,23500,23000,22500,22000,21500,21000,20500,20000,19500,19000,18500,18000,17500,17000,16500,16000,15500];
  }
  if (et === "SENIOR PENETRATION TESTER") {
    return [55000,54500,54000,53500,53000,52500,52000,51500,51000,50500,50000,49500,49000,48500,48000,47500,47000,46500,46000,45500,45000,44500,44000,43500,43000,42500,42000];
  }
  return [];
}, [finalFeeRecord?.EnrollmentType]);

// whether the current finalFeeValue matches one of the presets
const isMatchedPreset = useMemo(() => {
  if (finalFeeValue == null) return false;
  return presetOptions.includes(Number(finalFeeValue));
}, [finalFeeValue, presetOptions]);

// keep local customAmount in sync if external finalFeeValue changes
useEffect(() => {
  if (finalFeeValue != null) {
    setCustomAmount(String(finalFeeValue));
  } else {
    setCustomAmount("");
  }
}, [finalFeeValue]);



const [changeBatchModalVisible, setChangeBatchModalVisible] = useState(false);
const [changeBatchRecord, setChangeBatchRecord] = useState(null);
const [changedBatchDate, setChangedBatchDate] = useState(null);
const [changeBatchLoading, setChangeBatchLoading] = useState(false);

const handleChangeAvailabilityBatch = async () => {
  if (!changeBatchRecord?.Email) {
    toast.error("Email not found");
    return;
  }
  if (!changedBatchDate) {
    toast.error("Please select a date");
    return;
  }

  setChangeBatchLoading(true);
  try {
    const base = process.env.REACT_APP_API_URL?.replace(/\/$/, "");
    const url = `${base}/nurturing/update-availability-batch`;

    const payload = {
      Email: changeBatchRecord.Email,
      ChangedBatch: changedBatchDate.format("DD-MM-YYYY"),
    };

    const res = await axios.put(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      timeout: 15000,
    });

    if (res?.status === 200 || res?.status === 201 || res?.data?.success) {
      toast.success(res?.data?.message || "Batch updated");

      // update table locally
      setLeads((prev) =>
        prev.map((r) =>
          (r.Email || "").toLowerCase() ===
          (changeBatchRecord.Email || "").toLowerCase()
            ? { ...r, AvailabilityBatch: payload.ChangedBatch }
            : r
        )
      );

      setChangeBatchModalVisible(false);
    } else {
      toast.error(res?.data?.message || "Failed to update batch");
    }
  } catch (err) {
    console.error("update-batch error", err);
    toast.error(
      err?.response?.data?.message ||
        err?.message ||
        "Server error"
    );
  } finally {
    setChangeBatchLoading(false);
  }
};


 let juniorFilter = filteredLeads.filter(r => {
    return r.EnrollmentType === 'JUNIOR PENETRATION TESTER'
  })

  let seniorFilter = filteredLeads.filter(r => {
    return r.EnrollmentType === 'SENIOR PENETRATION TESTER'
  })

  let studentFilter = filteredLeads.filter(r => {
    return r.LeadCategory === 'STUDENT'
  })

  let professionalFilter = filteredLeads.filter(r => {
    return r.LeadCategory === 'PROFESSIONAL'
  })


  const handleChangeLeadStatus = async () => {
    if (!leadStatusRecord?.Email) {
      toast.error("No email found for selected lead");
      return;
    }
  
    if (!leadStatusValue) {
      toast.error("Please select a lead status");
      return;
    }
  
    setLeadStatusLoading(true);
  
    try {
      const payload = {
        Email: leadStatusRecord.Email,
        LeadStatus: leadStatusValue,
      };
  
      const url = `${process.env.REACT_APP_API_URL?.replace(/\/$/, "")}/nurturing/update-Lead-Status`;
  
      const res = await axios.put(url, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        timeout: 15000,
      });
  
      if (res?.data?.success || [200, 201].includes(res?.status)) {
        toast.success(res?.data?.message || "Lead status updated");
  
        // update table locally
        setLeads(prev =>
          prev.map(l =>
            l.Email === leadStatusRecord.Email
              ? { ...l, LeadStatus: leadStatusValue }
              : l
          )
        );
  
        setLeadStatusModalVisible(false);
      } else {
        toast.error(res?.data?.message || "Failed to update lead status");
      }
    } catch (err) {
      console.error("Lead status update error", err);
      toast.error(
        err?.response?.data?.message || err.message || "Server error"
      );
    } finally {
      setLeadStatusLoading(false);
    }
  };
  

  return (
    <div className="w-full px-4 py-10 mx-auto bg-white shadow-sm sm:px-6 lg:px-8 rounded-xl">
      <ToastContainer
              position="bottom-left"
              autoClose={5000}
              hideProgressBar={true}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="dark"
              className="!mb-6 !ml-4"
              toastClassName="!inline-flex !items-center !whitespace-nowrap !bg-black !text-white !px-4 !py-2 !rounded-lg !w-auto !min-w-0 !shadow-lg"
            />

      <Title level={3} className="!text-3xl !font-bold text-gray-800 tracking-tight mb-3 border-b border-gray-200 pb-2">
        Nurturing Leads
      </Title>

      <Paragraph className="mb-6 text-base leading-relaxed text-gray-700">
        These are leads currently in the <strong>Nurturing</strong> stage. Use the search and category filters
        to find specific leads — click rows to inspect further or perform actions.
      </Paragraph>

      <p className="text-lg text-slate-700">
              You can access all lead details anytime from the{" "}
              <Link
                to={fullPath}
                className="inline-flex items-center gap-2 px-3 py-1 text-lg font-semibold text-red-600 bg-gray-100 rounded-md hover:bg-gray-200"
              >
                Nurturing Dashboard
              </Link>
            </p>

      {error && <Alert type="error" message="Error" description={error} showIcon closable className="mb-6" />}
  <div className="w-full mt-6">

{/* FILTER TOGGLE BUTTON */}
<div className="flex justify-end mb-3">
  <Button
    onClick={() => setShowFilters(!showFilters)}
    type="primary"
    className="
      font-bold
      px-5
      rounded-lg
      bg-gradient-to-r
      from-blue-700
      via-indigo-700
      to-purple-700
      border-none
      text-white
      shadow-[0_0_20px_rgba(79,70,229,0.8)]
      hover:shadow-[0_0_35px_rgba(79,70,229,1)]
      hover:scale-105
      animate-pulse
      transition-all
      duration-300
    "
  >
    {showFilters ? "Hide Filters" : "Show Filters"}
  </Button>
</div>

{/* Filters with transition */}
<div
  className={`overflow-hidden transition-all duration-500 ease-in-out ${
    showFilters
      ? "max-h-[900px] opacity-100 translate-y-0 mb-3"
      : "max-h-0 opacity-0 -translate-y-3 mb-0"
  }`}
>
<div className="p-5 border border-blue-100 shadow-[0_10px_35px_rgba(15,23,42,0.12)] bg-gradient-to-br from-white via-slate-50 to-blue-50 rounded-2xl">

  <div className="flex items-center gap-3 my-6 ml-4">
    {/* FullName Search */}
    <div className="flex items-center gap-2">
      <label className="text-sm font-semibold text-gray-700 whitespace-nowrap">Full Name</label>
      <Search
        placeholder="Search Full Name"
        allowClear
        value={filterFullNameText}
        onChange={(e) => setFilterFullNameText(e.target.value)}
        onSearch={(v) => setFilterFullNameText(v)}
        style={{
          minWidth: 260,
          borderColor: '#4b5563',
          borderWidth: '2px',
          borderRadius: '0.5rem',
          color: '#9ca3af',
        }}
        enterButton={false}
      />
    </div>

    {/* Email Search */}
    <div className="flex items-center gap-2">
      <label className="text-sm font-semibold text-gray-700">Email</label>
      <Search
        placeholder="Search email"
        allowClear
        value={filterEmailText}
        onChange={(e) => setFilterEmailText(e.target.value)}
        onSearch={(v) => setFilterEmailText(v)}
        style={{
          minWidth: 260,
          borderColor: '#4b5563',
          borderWidth: '2px',
          borderRadius: '0.5rem',
          color: '#9ca3af',
        }}
        enterButton={false}
      />
    </div>

    <div className="flex-grow ml-4 border-2 border-t border-gray-400"></div>
  </div>

  {/* Filters toolbar */}
  <div className="flex flex-col gap-4 mb-7 md:flex-row md:items-center md:justify-between">
    <div className="flex flex-wrap items-center gap-3">
      {/* Lead Category */}
      <div className="flex items-center gap-2 ml-4">
        <label className="text-sm font-semibold text-gray-700">Lead Category</label>
        <Select
          placeholder={<span style={{ color: '#4b5563' }}>All</span>}
          value={filterCategory}
          onChange={(v) => setFilterCategory(v || null)}
          allowClear
          style={{ minWidth: 160, borderColor: '#4b5563', borderWidth: '2px', borderRadius: '0.5rem', color: '#9ca3af' }}
          options={[
            { label: 'Student', value: 'STUDENT' },
            { label: 'Professional', value: 'PROFESSIONAL' },
          ]}
        />
      </div>

      {/* Lead Source (multi) */}
      <div className="flex items-center gap-2">
        <label className="text-sm font-semibold text-gray-700">Lead Source</label>
        <Select
          mode="multiple"
          placeholder={<span style={{ color: '#4b5563' }}>Select Source</span>}
          value={filterSources}
          onChange={(v) => setFilterSources(v || [])}
          allowClear
          style={{ minWidth: 220, borderColor: '#4b5563', borderWidth: '2px', borderRadius: '0.5rem', color: '#9ca3af' }}
          options={[
            { label: 'Google', value: 'GOOGLE' },
            { label: 'Meta', value: 'META' },
            { label: 'Meta-Instagram', value: 'META-INSTAGRAM' },
             { label: 'Meta-Facebook', value: 'META-FACEBOOK' },
            { label: 'LinkedIn', value: 'LINKEDIN' },
            { label: 'Organic', value: 'ORGANIC' },
             { label: 'Youtube', value: 'YOUTUBE' },
             { label: 'Youtube-Infeed', value: 'YOUTUBE-YIF' },
                       { label: 'Youtube-Instream', value: 'YOUTUBE-YIS' },
          ]}
        />
      </div>

      {/* Availability Batch Month */}
      <div className="flex items-center gap-2">
        <label className="text-sm font-semibold text-gray-700">Availability Month</label>
        <Select
          placeholder={<span style={{ color: '#4b5563' }}>Select Month</span>}
          value={filterAvailabilityMonth}
          onChange={(v) => setFilterAvailabilityMonth(v || null)}
          allowClear
          style={{ minWidth: 140, borderColor: '#4b5563', borderWidth: '2px', borderRadius: '0.5rem', color: '#9ca3af' }}
          options={[
            { label: 'JANUARY', value: 'JANUARY' },
            { label: 'FEBRUARY', value: 'FEBRUARY' },
            { label: 'MARCH', value: 'MARCH' },
            { label: 'APRIL', value: 'APRIL' },
            { label: 'MAY', value: 'MAY' },
            { label: 'JUNE', value: 'JUNE' },
            { label: 'JULY', value: 'JULY' },
            { label: 'AUGUST', value: 'AUGUST' },
            { label: 'SEPTEMBER', value: 'SEPTEMBER' },
            { label: 'OCTOBER', value: 'OCTOBER' },
            { label: 'NOVEMBER', value: 'NOVEMBER' },
            { label: 'DECEMBER', value: 'DECEMBER' },
          ]}
        />
      </div>

      {/* Batch Day (multi) */}
      <div className="flex items-center gap-2">
        <label className="text-sm font-semibold text-gray-700">Batch Day</label>
        <Select
          mode="multiple"
          placeholder={<span style={{ color: '#4b5563' }}>Select Batch Day</span>}
          value={filterBatchDays}
          onChange={(v) => setFilterBatchDays(v || [])}
          allowClear
          style={{ minWidth: 160, borderColor: '#4b5563', borderWidth: '2px', borderRadius: '0.5rem', color: '#9ca3af' }}
          options={[
            { label: 'Morning', value: 'MORNING' },
            { label: 'Evening', value: 'EVENING' },
          ]}
        />
      </div>

      {/* Call Status */}
      <div className="flex items-center gap-2">
        <label className="text-sm font-semibold text-gray-700">Call Status</label>
        <Select
          placeholder={<span style={{ color: '#4b5563' }}>Any</span>}
          value={filterCallStatus}
          onChange={(v) => setFilterCallStatus(v || null)}
          allowClear
          style={{ minWidth: 140, borderColor: '#4b5563', borderWidth: '2px', borderRadius: '0.5rem', color: '#9ca3af' }}
          options={[
            { label: 'PENDING', value: 'PENDING' },
            { label: 'INTERESTED', value: 'INTERESTED' },
             { label: 'NOT INTERESTED', value: 'NOT INTERESTED' },
              { label: 'FOLLOW UP', value: 'FOLLOW UP' },
          ]}
        />
      </div>

      {/* Negotiation Status */}
      <div className="flex items-center gap-2 ml-4">
        <label className="text-sm font-semibold text-gray-700">Negotiation Status</label>
        <Select
          placeholder={<span style={{ color: '#4b5563' }}>Any</span>}
          value={filterNegotiationStatus}
          onChange={(v) => setFilterNegotiationStatus(v || null)}
          allowClear
          style={{ minWidth: 160, borderColor: '#4b5563', borderWidth: '2px', borderRadius: '0.5rem', color: '#9ca3af' }}
          options={[
            { label: 'PENDING', value: 'PENDING' },
            { label: 'COMPLETED', value: 'COMPLETED' },
          ]}
        />
      </div>

      {/* Enrollment Type */}
<div className="flex items-center gap-2">
  <label className="text-sm font-semibold text-gray-700">Enrollment Type</label>
  <Select
    placeholder={<span style={{ color: '#4b5563' }}>Any</span>}
    value={filterEnrollmentType}
    onChange={(v) => setFilterEnrollmentType(v || null)}
    allowClear
    style={{
      minWidth: 220,
      borderColor: '#4b5563',
      borderWidth: '2px',
      borderRadius: '0.5rem',
      color: '#9ca3af',
    }}
    options={[
      { label: 'JUNIOR PENETRATION TESTER', value: 'JUNIOR PENETRATION TESTER' },
      { label: 'SENIOR PENETRATION TESTER', value: 'SENIOR PENETRATION TESTER' },
    ]}
  />
</div>

{/* Installment */}
<div className="flex items-center gap-2">
  <label className="text-sm font-semibold text-gray-700">Installment</label>
  <Select
    placeholder={<span style={{ color: '#4b5563' }}>Any</span>}
    value={filterInstallment}
    onChange={(v) => setFilterInstallment(v || null)}
    allowClear
    style={{
      minWidth: 120,
      borderColor: '#4b5563',
      borderWidth: '2px',
      borderRadius: '0.5rem',
      color: '#9ca3af',
    }}
    options={[
      { label: 'YES', value: 'YES' },
      { label: 'NO', value: 'NO' },
    ]}
  />
</div>


      {/* ReasonForNotInterest */}
      <div className="flex items-center gap-2">
        <label className="text-sm font-semibold text-gray-700">Reason</label>
        <Select
          placeholder={<span style={{ color: '#4b5563' }}>Any</span>}
          value={filterReason}
          onChange={(v) => setFilterReason(v || null)}
          allowClear
          style={{ minWidth: 220, borderColor: '#4b5563', borderWidth: '2px', borderRadius: '0.5rem', color: '#9ca3af' }}
          options={[
            { label: 'NOT APPLICABLE', value: 'NOT APPLICABLE' },
            { label: 'HIGH FEE', value: 'HIGH FEE' },
            { label: 'DEMO NOT LIKED', value: 'DEMO NOT LIKED' },
            { label: 'INSTRUCTOR NOT LIKED', value: 'INSTRUCTOR NOT LIKED' },
            { label: 'UNAVAILABLE FOR CURRENT BATCH', value: 'UNAVAILABLE FOR CURRENT BATCH' },
            { label: 'TIMINGS NOT SET', value: 'TIMINGS NOT SET' },
            { label: 'SWITCHED OFF', value: 'SWITCHED OFF' },
            { label: 'UNANSWERED', value: 'UNANSWERED' },
          ]}
        />
      </div>

      {/* Clear Filters button (right side of toolbar) */}
  <div className="ml-4">
    <Button
      onClick={clearFilters}
      icon={<UndoOutlined />}
      type="default"
      className="font-semibold text-black bg-blue-400 border border-gray-400 hover:bg-gray-50"
    >
      Clear Filters
    </Button>
  </div>

    </div>
    </div>
    </div>
    </div>


     <div className="flex items-center gap-4 mb-5">
  <div className="px-4 py-3 bg-blue-200 border border-gray-600 rounded-md shadow-sm">
    <div className="text-xs font-bold tracking-wide text-black uppercase">
      Total Leads
    </div>
    <div className="mt-1 text-4xl font-extrabold text-center text-black">
      {filteredLeads.length}
    </div>
  </div> 

   <div className="px-4 py-3 bg-blue-200 border border-gray-600 rounded-md shadow-sm">
    <div className="text-xs font-bold tracking-wide text-black uppercase">
      Student Leads
    </div>
    <div className="mt-1 text-4xl font-extrabold text-center text-black">
      {studentFilter.length}
    </div>
  </div> 

<div className="px-4 py-3 bg-blue-200 border border-gray-600 rounded-md shadow-sm">
    <div className="text-xs font-bold tracking-wide text-black uppercase">
      Professional Leads
    </div>
    <div className="mt-1 text-4xl font-extrabold text-center text-black">
      {professionalFilter.length}
    </div>
  </div> 
  
  <div className="px-4 py-3 bg-blue-200 border border-gray-600 rounded-md shadow-sm">
    <div className="text-xs font-bold tracking-wide text-black uppercase">
      Junior
    </div>
    <div className="mt-1 text-4xl font-extrabold text-center text-black">
      {juniorFilter.length}
    </div>
  </div> 

  <div className="px-4 py-3 bg-blue-200 border border-gray-600 rounded-md shadow-sm">
    <div className="text-xs font-bold tracking-wide text-black uppercase">
      Senior
    </div>
    <div className="mt-1 text-4xl font-extrabold text-center text-black">
      {seniorFilter.length}
    </div>
  </div> 
</div>

  

      {/* Table */}
    
        <Table
          dataSource={filteredLeads}
          columns={nurturingColumns}
          rowKey={(r) => r.key}
          loading={loading}
          pagination={{ pageSize: 20, total: filteredLeads.length }}
          scroll={{ x: 2500 }}
         className="font-semibold text-center border border-gray-200 rounded-lg shadow-sm gray-header-table-nurturing"
         
        />
      </div>

        {/* Action Modal */}
            <Modal
              title={<div className="flex items-center justify-center w-full"><span className="text-xl font-bold text-gray-900">Choose action for lead</span></div>}
              open={actionModalVisible}
              onCancel={() => setActionModalVisible(false)}
              footer={null}
              centered
              width={520}
              bodyStyle={{ padding: 24 }}
            >
              <div className="space-y-4">
                <div className="text-sm text-gray-700">
                  Performing action for: <strong>{actionRecord?.FullName ?? actionRecord?.Email ?? '-'}</strong>
                  {actionRecord?.PhoneNumber ? <span className="ml-2 text-xs font-semibold text-gray-700">({actionRecord.PhoneNumber})</span> : null}
                </div>
      
                <div className="flex flex-col gap-3">
                  <button onClick={() => handleMoveToFirstInstallment(actionRecord)} disabled={!actionRecord || movingKeys.has(`move-nurture-${actionRecord?.key}`)} className={`w-full px-5 py-3 rounded-xl text-white font-semibold shadow-md transition-transform active:scale-[0.99] ${movingKeys.has(`move-nurture-${actionRecord?.key}`) ? 'bg-blue-400 cursor-wait' : 'bg-blue-600 hover:bg-blue-700'}`} type="button">
                    {movingKeys.has(`move-nurture-${actionRecord?.key}`) ? <span className="inline-flex items-center gap-2"><Spin size="small" />Moving...</span> : 'Move To First Installment Stage'}
                  </button>
      
                 {/* Move to Upcoming Batch */}
      <button
        onClick={() => openUpcomingModal(actionRecord)}
        disabled={!actionRecord || movingKeys.has(`move-upcoming-${actionRecord?.key}`)}
        className={`w-full px-5 py-3 rounded-xl text-white font-semibold shadow-md transition-transform active:scale-[0.99] ${movingKeys.has(`move-upcoming-${actionRecord?.key}`) ? 'bg-indigo-400 cursor-wait' : 'bg-gray-600 hover:bg-gray-900'}`}
        type="button"
      >
        {movingKeys.has(`move-upcoming-${actionRecord?.key}`) ? <span className="inline-flex items-center gap-2"><Spin size="small" />Moving...</span> : 'Move To Upcoming Batch'}
      </button>
      
                  <button onClick={() => { setDropComments(''); setDropModalVisible(true); }} disabled={!actionRecord || movingKeys.has(`drop-lead-${actionRecord?.key}`)} className={`w-full px-5 py-3 rounded-xl text-white font-semibold shadow-md transition-transform active:scale-[0.99] ${movingKeys.has(`drop-lead-${actionRecord?.key}`) ? 'bg-gray-400 cursor-wait' : 'bg-red-600 hover:bg-red-700'}`} type="button">
                    Drop The Lead
                  </button>
                </div>
              </div>
            </Modal>
      
            {/* Upcoming Batch Modal */}
      <Modal
        title={<span className="text-lg font-bold">Move To Upcoming Batch</span>}
        open={upcomingModalVisible}
        onCancel={() => setUpcomingModalVisible(false)}
        footer={null}
        centered
        width={1000}
      >
        <div className="space-y-4">
          <div className="text-gray-800 text-md">
            Moving lead: <strong>{actionRecord?.FullName ?? actionRecord?.Email ?? '-'}</strong>
          </div>
            <div className="mb-2 text-sm text-gray-800">
            Current Batch : <strong className='text-red-800'>{actionRecord?.AvailabilityBatch ?? '-'}</strong>
          </div>
          <div className="mb-4 text-sm text-gray-800">
            Batch day : <strong className='text-green-800'>{actionRecord?.BatchDay ?? '-'}</strong>
          </div>
      
          <div>
            <label className="block mb-1 text-gray-800 text-md">Email</label>
            <input type="text" value={actionRecord?.Email ?? ''} readOnly className="w-full px-3 py-2 font-semibold bg-gray-100 border border-gray-200 rounded-md text-md" />
          </div>
      
          <div>
            <label className="block mb-2 text-gray-800 text-md">Select Batch (choose one)</label>
      
            {upcomingModalLoading ? (
              <div className="flex items-center justify-center py-8"><Spin /></div>
            ) : (
              <Table
                dataSource={upcomingDemoLinks}
                columns={demoLinksColumns}
                rowKey={(r) => r.key}
                pagination={{ pageSize: 15 }}
                size="small"
                className="font-semibold text-center border border-gray-200 rounded-lg shadow-sm gray-header-table"
                scroll={{ x: 1400 }}
                rowSelection={{
                  type: 'radio',
                  selectedRowKeys: selectedUpcomingDemoKey ? [selectedUpcomingDemoKey] : [],
                  onChange: (keys, rows) => {
                    setSelectedUpcomingDemoKey(keys && keys[0] ? keys[0] : null);
                  }
                }}
                onRow={(rec) => ({
                  onClick: () => handleSelectUpcomingRow(rec),
                  tabIndex: 0,
                  onKeyDown: (e) => {
                    if (e.key === 'Enter' || e.key === ' ') handleSelectUpcomingRow(rec);
                  }
                })}
              />
            )}
          </div>
      
          <div>
            <label className="block mb-1 text-gray-800 text-md">Comments</label>
            <TextArea rows={3} value={upcomingComments} onChange={(e) => setUpcomingComments(e.target.value)} placeholder="Please give comments..." />
          </div>
      
          <div className="flex items-center justify-end gap-3">
            <Button onClick={() => setUpcomingModalVisible(false)} disabled={upcomingModalLoading}>Cancel</Button>
      
            <Button
              type="primary"
              onClick={handleConfirmMoveToUpcomingBatch}
              disabled={!selectedUpcomingDemoKey || Boolean(upcomingModalLoading) || Boolean(upcomingMovingKey)}
              className="bg-blue-600"
            >
              {(Boolean(upcomingMovingKey) || upcomingModalLoading) ? <span className="inline-flex items-center gap-2 font-semibold"><Spin size="small" />Moving...</span> : 'Move To Upcoming Batch'}
            </Button>
          </div>
        </div>
      </Modal>
      
      
            {/* Drop Modal */}
            <Modal
              title={<span className="text-lg font-bold">Drop Lead</span>}
              visible={dropModalVisible}
              onCancel={() => setDropModalVisible(false)}
              footer={null}
              centered
              width={560}
            >
              <div className="space-y-4">
                <div className="text-sm text-gray-700">Dropping lead: <strong>{actionRecord?.FullName ?? actionRecord?.Email ?? '-'}</strong></div>
      
                <div>
                  <label className="block mb-1 text-sm text-gray-700">Email</label>
                  <input type="text" value={actionRecord?.Email ?? ''} readOnly className="w-full px-3 py-2 text-sm font-semibold bg-gray-100 border border-gray-200 rounded-md" />
                </div>
      
                <div>
                  <label className="block mb-1 text-sm text-gray-700">Comments</label>
                  <TextArea value={dropComments} onChange={(e) => setDropComments(e.target.value)} rows={4} placeholder="Reason / notes for dropping this lead..." />
                </div>
      
                <div className="flex items-center justify-end gap-3">
                  <button onClick={() => setDropModalVisible(false)} className="px-4 py-2 text-gray-700 bg-white border border-gray-200 rounded-md" type="button" disabled={dropLoading}>Cancel</button>
                  <button onClick={() => handleDropLeadConfirm(actionRecord)} className={`px-5 py-2.5 rounded-md text-white font-semibold ${dropLoading ? 'bg-gray-400 cursor-wait' : 'bg-red-600 hover:bg-red-700'}`} type="button" disabled={dropLoading}>
                    {dropLoading ? <span className="inline-flex items-center gap-2"><Spin size="small" /> Dropping...</span> : 'Drop Lead'}
                  </button>
                </div>
              </div>
            </Modal>

            <Modal
  title={<span className="text-lg font-bold">Change Call Status</span>}
  open={callStatusModalVisible}
  onCancel={() => setCallStatusModalVisible(false)}
  footer={null}
  centered
  width={520}
>
  <div className="space-y-4">
    <div>
       <div className="mb-2 text-sm text-gray-800">
            Full Name : <strong className='text-red-800'>{callStatusRecord?.FullName ?? '-'}</strong>
          </div>
      <label className="block mb-1 text-gray-600 text-md">Email</label>
      <input
        type="text"
        value={callStatusRecord?.Email ?? ''}
        readOnly
        className="w-full px-3 py-2 text-sm font-bold bg-gray-100 border border-gray-200 rounded-md"
      />
    </div>

    <div>
      <label className="block mb-1 text-gray-600 text-md">Call Status</label>
      <Select
        value={callStatusValue}
        onChange={(v) => setCallStatusValue(v)}
        placeholder="Select status"
        style={{ width: '100%' }}
        options={[
          { label: 'INTERESTED', value: 'INTERESTED' },
          { label: 'NOT INTERESTED', value: 'NOT INTERESTED' },
          { label: 'FOLLOW UP', value: 'FOLLOW UP' },
          { label: 'CONNECT TO INSTRUCTOR', value: 'CONNECT TO INSTRUCTOR' },
        ]}
        disabled={callStatusLoading}
      />
    </div>

    <div className="flex items-center justify-end gap-3">
      <Button onClick={() => setCallStatusModalVisible(false)} disabled={callStatusLoading}>Cancel</Button>
      <Button
        type="primary"
        onClick={handleChangeCallStatus}
        disabled={callStatusLoading || !callStatusValue}
        className="bg-blue-600"
      >
        {callStatusLoading ? <span className="inline-flex items-center gap-2"><Spin size="small" /> Changing...</span> : 'Change Call Status'}
      </Button>
    </div>
  </div>
</Modal>

<Modal
  title={<span className="text-lg font-bold">Change Negotiation Status</span>}
  open={negotiationModalVisible}
  onCancel={() => setNegotiationModalVisible(false)}
  footer={null}
  centered
  width={520}
>
  <div className="space-y-4">
    <div>
       <div className="mb-2 text-sm text-gray-800">
            Full Name : <strong className='text-red-800'>{negotiationRecord?.FullName ?? '-'}</strong>
          </div>
      <label className="block mb-1 text-gray-600 text-md">Email</label>
      <input
        type="text"
        value={negotiationRecord?.Email ?? ''}
        readOnly
        className="w-full px-3 py-2 text-sm font-bold bg-gray-100 border border-gray-200 rounded-md"
      />
    </div>

    <div>
      <label className="block mb-1 text-gray-600 text-md">Negotiation Status</label>
      <Select
        value={negotiationValue}
        onChange={(v) => setNegotiationValue(v)}
        placeholder="Select status"
        style={{ width: '100%' }}
        options={[
          { label: 'COMPLETED', value: 'COMPLETED' },
          { label: 'PENDING', value: 'PENDING' },
        ]}
        disabled={negotiationLoading}
      />
    </div>

    <div className="flex items-center justify-end gap-3">
      <Button onClick={() => setNegotiationModalVisible(false)} disabled={negotiationLoading}>Cancel</Button>
      <Button
        type="primary"
        onClick={handleChangeNegotiationStatus}
        disabled={negotiationLoading || !negotiationValue}
        className="bg-blue-600"
      >
        {negotiationLoading ? <span className="inline-flex items-center gap-2"><Spin size="small" /> Changing...</span> : 'Change Negotiation Status'}
      </Button>
    </div>
  </div>
</Modal>

<Modal
  title={<span className="text-lg font-bold">Change Enrollment Type</span>}
  open={enrollmentModalVisible}
  onCancel={() => setEnrollmentModalVisible(false)}
  footer={null}
  centered
  width={620}
>
  <div className="space-y-4">
    <div>
      <div className="mb-2 text-sm text-gray-800">
            Full Name : <strong className='text-red-800'>{enrollmentRecord?.FullName ?? '-'}</strong>
          </div>
      <label className="block mb-1 text-gray-600 text-md">Email</label>
      <input
        type="text"
        value={enrollmentRecord?.Email ?? ''}
        readOnly
        className="w-full px-3 py-2 text-sm font-bold bg-gray-100 border border-gray-200 rounded-md"
      />
    </div>

    <div>
      <label className="block mb-1 text-gray-600 text-md">Enrollment Type</label>
      <Select
        value={enrollmentValue}
        onChange={(v) => setEnrollmentValue(v)}
        placeholder="Select Enrollment Type"
        style={{ width: '100%' }}
        options={[
          { label: 'JUNIOR PENETRATION TESTER', value: 'JUNIOR PENETRATION TESTER' },
          { label: 'SENIOR PENETRATION TESTER', value: 'SENIOR PENETRATION TESTER' },
        ]}
        disabled={enrollmentLoading}
      />
    </div>

    <div className="flex items-center justify-end gap-3">
      <Button onClick={() => setEnrollmentModalVisible(false)} disabled={enrollmentLoading}>Cancel</Button>

      <Button
        type="primary"
        onClick={handleChangeEnrollmentType}
        disabled={enrollmentLoading || !enrollmentValue}
        className="bg-blue-600"
      >
        {enrollmentLoading ? <span className="inline-flex items-center gap-2"><Spin size="small" /> Changing...</span> : 'Change Enrollment Type'}
      </Button>
    </div>
  </div>
</Modal>

<Modal
  title={<span className="text-lg font-bold">Change Final Fee</span>}
  open={finalFeeModalVisible}
  onCancel={() => setFinalFeeModalVisible(false)}
  footer={null}
  centered
  width={620}
>
  <div className="space-y-4">
    <div>
      <div className="mb-2 text-sm text-gray-800">
        Full Name :{" "}
        <strong className="text-red-800">{finalFeeRecord?.FullName ?? "-"}</strong>
      </div>
      <label className="block mb-1 text-gray-600 text-md">Email</label>
      <input
        type="text"
        value={finalFeeRecord?.Email ?? ""}
        readOnly
        className="w-full px-3 py-2 text-sm font-bold bg-gray-100 border border-gray-200 rounded-md"
      />
    </div>

    <div>
      <label className="block mb-1 text-gray-600 text-md">Enrollment Type</label>
      <input
        type="text"
        value={finalFeeRecord?.EnrollmentType ?? "-"}
        readOnly
        className="w-full px-3 py-2 text-sm border border-gray-200 rounded-md bg-gray-50"
      />
    </div>

    {/* Select + Custom Input Block */}
   <div>
  <label className="block mb-1 text-gray-600 text-md">
    Enter Final Fee
  </label>

  <Input
    type="number"
    value={finalFeeValue}
    onChange={(e) => {
      const value = e.target.value;
      setFinalFeeValue(value === "" ? null : Number(value));
    }}
    placeholder="Enter final fee amount"
    disabled={finalFeeLoading}
    className="!h-11"
    style={{ width: "100%" }}
  />

  <div className="mt-1 text-xs font-semibold text-gray-500">
    Enter the actual final fee agreed with the lead.
  </div>
</div>

    {/* Footer buttons */}
    <div className="flex items-center justify-end gap-3">
      <Button onClick={() => setFinalFeeModalVisible(false)} disabled={finalFeeLoading}>
        Cancel
      </Button>

      <Button
        type="primary"
        onClick={handleChangeFinalFee}
        disabled={
          finalFeeLoading ||
          finalFeeValue === null ||
          finalFeeValue === undefined ||
          Number.isNaN(finalFeeValue)
        }
        className="bg-blue-600"
      >
        {finalFeeLoading ? (
          <span className="inline-flex items-center gap-2">
            <Spin size="small" /> Changing...
          </span>
        ) : (
          "Change Final Fee"
        )}
      </Button>
    </div>
  </div>
</Modal>

<Modal
  title={<span className="text-lg font-bold">Change Installment</span>}
  open={installmentModalVisible}
  onCancel={() => setInstallmentModalVisible(false)}
  footer={null}
  centered
  width={620}
>
  <div className="space-y-4">
    <div>
      <div className="mb-2 text-sm text-gray-800">
            Full Name : <strong className='text-red-800'>{installmentRecord?.FullName ?? '-'}</strong>
          </div>
      <label className="block mb-1 text-gray-600 text-md">Email</label>
      <input
        type="text"
        value={installmentRecord?.Email ?? ''}
        readOnly
        className="w-full px-3 py-2 text-sm font-bold bg-gray-100 border border-gray-200 rounded-md"
      />
    </div>

    <div>
      <label className="block mb-1 text-gray-600 text-md">Installment</label>
      <Select
        value={installmentValue}
        onChange={(v) => setInstallmentValue(v)}
        placeholder="Select Installment"
        style={{ width: '50%' }}
        disabled={installmentLoading}
        options={[
          { label: 'YES', value: 'YES' },
          { label: 'NO', value: 'NO' },
        ]}
      />
    </div>

    <div className="flex items-center justify-end gap-3">
      <Button onClick={() => setInstallmentModalVisible(false)} disabled={installmentLoading}>Cancel</Button>

      <Button
        type="primary"
        onClick={handleChangeInstallment}
        disabled={installmentLoading || !installmentValue}
        className="bg-blue-600"
      >
        {installmentLoading ? <span className="inline-flex items-center gap-2"><Spin size="small" /> Changing...</span> : 'Change Installment'}
      </Button>
    </div>
  </div>
</Modal>

<Modal
  title={<span className="text-lg font-bold">Change Reason - Not Interested</span>}
  open={reasonModalVisible}
  onCancel={() => setReasonModalVisible(false)}
  footer={null}
  centered
  width={620}
>
  <div className="space-y-4">
    <div>
      <div className="mb-2 text-sm text-gray-800">
            Full Name : <strong className='text-red-800'>{reasonRecord?.FullName ?? '-'}</strong>
          </div>
      <label className="block mb-1 text-gray-600 text-md">Email</label>
      <input
        type="text"
        value={reasonRecord?.Email ?? ''}
        readOnly
        className="w-full px-3 py-2 text-sm font-bold bg-gray-100 border border-gray-200 rounded-md"
      />
    </div>

    <div>
      <label className="block mb-1 text-gray-600 text-md">Reason</label>
      <Select
        value={reasonValue}
        onChange={(v) => setReasonValue(v)}
        placeholder="Select reason"
        style={{ width: '100%' }}
        disabled={reasonLoading}
        options={[
          { label: 'NOT APPLICABLE', value: 'NOT APPLICABLE' },
          { label: 'HIGH FEE', value: 'HIGH FEE' },
          { label: 'DEMO NOT LIKED', value: 'DEMO NOT LIKED' },
          { label: 'INSTRUCTOR NOT LIKED', value: 'INSTRUCTOR NOT LIKED' },
          { label: 'UNAVAILABLE FOR CURRENT BATCH', value: 'UNAVAILABLE FOR CURRENT BATCH' },
          { label: 'TIMINGS NOT SET', value: 'TIMINGS NOT SET' },
          { label: 'SWITCHED OFF', value: 'SWITCHED OFF' },
          { label: 'UNANSWERED', value: 'UNANSWERED' },
        ]}
      />
    </div>

    <div className="flex items-center justify-end gap-3">
      <Button onClick={() => setReasonModalVisible(false)} disabled={reasonLoading}>Cancel</Button>

      <Button
        type="primary"
        onClick={handleChangeReason}
        disabled={reasonLoading || !reasonValue}
        className="bg-blue-600"
      >
        {reasonLoading ? <span className="inline-flex items-center gap-2"><Spin size="small" /> Changing...</span> : 'Change Reason'}
      </Button>
    </div>
  </div>
</Modal>



<Modal
  title={<span className="text-lg font-bold">Change Availability Batch</span>}
  open={changeBatchModalVisible}
  onCancel={() => setChangeBatchModalVisible(false)}
  footer={null}
  centered
  width={520}
>
  <div className="space-y-4">

    {/* FULL NAME */}
    <div className="text-gray-800 text-md">
      Full Name :{" "}
      <strong className="text-red-800">
        {changeBatchRecord?.FullName ?? "-"}
      </strong>
    </div>
    
    <div className="text-gray-800 text-md">
      Current Batch :{" "}
      <strong className="text-cyan-800">
        {changeBatchRecord?.AvailabilityBatch ?? "-"}
      </strong>
    </div>
    
     <div className="text-gray-800 text-md">
      Current Batch Day :{" "}
      <strong className="text-green-800">
        {changeBatchRecord?.BatchDay ?? "-"}
      </strong>
    </div>

    {/* EMAIL */}
    <div>
      <label className="block mb-1 font-medium text-gray-700">Email</label>
      <input
        type="text"
        value={changeBatchRecord?.Email ?? ""}
        readOnly
        className="w-full px-3 py-2 text-sm font-semibold bg-gray-100 border rounded"
      />
    </div>

    {/* DATE PICKER */}
    <div>
      <label className="block mb-1 font-medium text-gray-700">
        Select New Batch Date
      </label>
      <DatePicker
        value={changedBatchDate}
        onChange={(d) => setChangedBatchDate(d)}
        format="DD-MM-YYYY"
        className="w-full"
        disabled={changeBatchLoading}
      />
    </div>

    {/* ACTIONS */}
    <div className="flex justify-end gap-3 pt-2">
      <Button
        onClick={() => setChangeBatchModalVisible(false)}
        disabled={changeBatchLoading}
      >
        Cancel
      </Button>

      <Button
        type="primary"
        className="bg-blue-600"
        disabled={!changedBatchDate || changeBatchLoading}
        onClick={handleChangeAvailabilityBatch}
      >
        {changeBatchLoading ? (
          <span className="inline-flex items-center gap-2">
            <Spin size="small" /> Updating...
          </span>
        ) : (
          "Change Batch"
        )}
      </Button>
    </div>
  </div>
</Modal>

<Modal
  title="Change Lead Status"
  open={leadStatusModalVisible}
  onCancel={() => setLeadStatusModalVisible(false)}
  footer={null}
  destroyOnClose
>
  <div className="space-y-4">

    {/* Lead Info */}
    <div className="p-3 space-y-1 border rounded-md bg-gray-50">
      <p className="text-sm">
        <span className="font-bold text-gray-600">Name:</span>{" "}
        <span className="font-bold text-gray-900">
          {leadStatusRecord?.FullName || leadStatusRecord?.Name || "-"}
        </span>
      </p>

      <p className="text-sm">
        <span className="font-bold text-gray-600">Email:</span>{" "}
        <span className="font-bold text-gray-900">
          {leadStatusRecord?.Email || "-"}
        </span>
      </p>
    </div>

    {/* Status Dropdown */}
    <Select
      placeholder="Select Lead Status"
      value={leadStatusValue}
      onChange={setLeadStatusValue}
      className="w-[50%]"
      options={[
        { label: "HOT LEAD", value: "HOT LEAD" },
        { label: "WARM LEAD", value: "WARM LEAD" },
        { label: "COLD LEAD", value: "COLD LEAD" },
      ]}
    />

    {/* Action Button */}
    <Button
      type="primary"
      block
      loading={leadStatusLoading}
      onClick={handleChangeLeadStatus}
      disabled={!leadStatusValue}
    >
      Change Lead Status
    </Button>
  </div>
</Modal>

<Modal
  title={<span className="text-lg font-bold">Update Nurturing Comment</span>}
  open={commentModalVisible}
  onCancel={() => {
    setCommentModalVisible(false);
    setCommentRecord(null);
    setCommentValue("");
  }}
  footer={null}
  centered
  width={560}
>
  <div className="space-y-4">
    <div className="p-4 border border-gray-200 rounded-lg bg-gray-50">
      <div className="mb-2 text-sm text-gray-800">
        Full Name :{" "}
        <strong className="text-red-800">
          {commentRecord?.FullName ?? "-"}
        </strong>
      </div>

      <div className="mb-2 text-sm text-gray-800">
        Email :{" "}
        <strong className="text-blue-800">
          {commentRecord?.Email ?? "-"}
        </strong>
      </div>

      <div className="text-sm text-gray-800">
        Phone Number :{" "}
        <strong className="text-green-800">
          {commentRecord?.PhoneNumber ?? "-"}
        </strong>
      </div>
    </div>

    <Input.TextArea
      rows={5}
      value={commentValue}
      onChange={(e) => setCommentValue(e.target.value)}
      placeholder="Enter nurturing lead comment..."
      disabled={commentLoading}
      maxLength={1000}
      showCount
    />

    <div className="flex items-center justify-end gap-3">
      <Button
        onClick={() => {
          setCommentModalVisible(false);
          setCommentRecord(null);
          setCommentValue("");
        }}
        disabled={commentLoading}
      >
        Cancel
      </Button>

      <Button
        type="primary"
        onClick={handleUpdateComment}
        disabled={commentLoading || !commentValue.trim()}
        className="bg-blue-600"
      >
        {commentLoading ? (
          <span className="inline-flex items-center gap-2">
            <Spin size="small" /> Updating...
          </span>
        ) : (
          "Update Comment"
        )}
      </Button>
    </div>
  </div>
</Modal>

    </div>
  );
}
